import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FilterGenerique } from '@models/api/requests';
import { PagedResultDTO } from '@models/shared';
import { Direction } from '@angular/cdk/bidi';

@Injectable({
  providedIn: 'root'
})
export class DirectionService {
  module = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(private http: HttpClient) { }

  getAllDirectionsDemandes() {
    return this.http.get<any>(this.module + '/directions/all');
  }
  getListOfDirections(offset: number, limit: number, filtre: FilterGenerique | null = null): Observable<PagedResultDTO<Direction>> {
    let url = this.module + '/directions';
    let params = new HttpParams().set('page', offset).set('size', limit);

    if (filtre?.filterGenerique) {
      params = params.set('filterGenerique', filtre.filterGenerique);
    }

    return this.http.get<PagedResultDTO<Direction>>(`${this.module}/directions`, { params });
  }
  getDirectionsDemandesByPole(poleId: string) {
    return this.http.get<any>(this.module + '/directions/by-pole/' + poleId);
  }
  //mise à jour d'une direction
  modifierDirection(data: any, id: number) {
    return this.http.put<any>(this.module + '/directions/' + id, data);
  }

  getMyDirectionsByPole(poleId: string) {
    return this.http.get<any>(this.module + '/directions/mes/by-pole/' + poleId);
  }

  // getDirectionsDemandesByPole(id_pole: any) {
  //   return this.http.get<any>(this.module + '/directions/by-pole/' + id_pole).pipe(
  //     map(() => [
  //       {
  //         id: 'fc922964-0293-4244-a28d-4e7b93357886',
  //         libelle: 'POLE CABELU',
  //         structValidation: 'string',
  //         createdBy: 'string',
  //         lastModifiedBy: 'string',
  //         lastModifiedAt: '2024-12-23T10:10:47.586Z',
  //         pole: {
  //           id: 'fc922964-0293-4244-a28d-4e7b93357886',
  //           code: 'CAB',
  //           libelle: 'POLE CABELU'
  //         },
  //         lastModifiedDate: '2024-12-23T10:10:47.586Z',
  //         createdDate: '2024-12-23T10:10:47.586Z'
  //       }
  //     ])
  //   );
  // }
  getOrganigramme() {
    return this.http.get<any>(this.module + '/directions/organigramme');
  }
}
